import React, {useMemo, useRef} from "react"

import PropTypes from "prop-types"
import {Field} from "redux-form"

import {required} from "../../services/validation"
import SemanticFormField from "../SemanticFormField/semanticFormField"
import {TiledRadioButton} from "./components"

import "./style.scss"

const TiledRadioButtonsField = ({
    buttonsProps,
    disabled = false,
    flexDirection = "row",
    formValues,
    htmlLabel,
    isRequired = false,
    name,
    readOnlyValue,
    ...props
}) => {
    const radiogroupRef = useRef(null)
    const labelId = useMemo(() => `label-${name}`, [name])

    // Permet d'associer le label au radiogroup
    const labelWithId = useMemo(() => {
        if (!htmlLabel) {
            return null
        }

        if (React.isValidElement(htmlLabel)) {
            return React.cloneElement(htmlLabel, {id: labelId})
        }

        return <label id={labelId}>{htmlLabel}</label>
    }, [htmlLabel, labelId])

    return (
        <div className="tiled-radio-buttons-field">
            {labelWithId}
            <div
                aria-labelledby={labelWithId ? labelId : undefined}
                className={`tiled-radio-buttons flex-${flexDirection}`}
                ref={radiogroupRef}
                role="radiogroup"
            >
                {buttonsProps?.map(button => (
                    <Field
                        as={fieldProps => (
                            <TiledRadioButton
                                checked={
                                    readOnlyValue !== undefined
                                        ? readOnlyValue === button.value
                                        : formValues && formValues[name] === button.value
                                }
                                disabled={disabled}
                                icon={button.icon}
                                id={`${name}-${button.value}`}
                                key={button.key}
                                name={name}
                                onClick={event => fieldProps.onChange(event, {value: button.value})}
                                title={button.label}
                            />
                        )}
                        component={SemanticFormField}
                        id={`${name}-${button.value}`}
                        key={button.key}
                        name={name}
                        validate={isRequired ? required : null}
                        {...props}
                    />
                ))}
            </div>
        </div>
    )
}

TiledRadioButtonsField.propTypes = {
    buttonsProps: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string.isRequired,
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
    ).isRequired,
    disabled: PropTypes.bool,
    flexDirection: PropTypes.oneOf(["row", "column"]),
    formValues: PropTypes.object,
    htmlLabel: PropTypes.node,
    isRequired: PropTypes.bool,
    name: PropTypes.string.isRequired,
    readOnlyValue: PropTypes.string,
}

export default TiledRadioButtonsField
